import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import InputField from '../../../../reusable-components/InputField';
import { required } from '../../../../utils/validations';
import Header from '../../../../reusable-components/Header';
import Footer from '../../../../reusable-components/Footer';
import Spinner from '../../../../reusable-components/Spinner';
import PageHeader from '../../../../reusable-components/PageHeader';
import PageContent from '../../../../reusable-components/PageContent';
import Body from '../../../../reusable-components/Body';
import { getObjectType } from '../../../../utils/helpers';
import { Row, Col, Button } from 'react-bootstrap';
import { FaArrowRight } from "react-icons/fa";
import PropTypes from 'prop-types';
import '../../../../styles/object.less';

let timer = null

export default class ChooseObject extends Component {
  state = {
    isBoatloading: false,
    isHouseboatloading: false,
    isSteigerloading: false
  }

  componentWillUnmount() {
    if (timer) clearTimeout(timer);
  }

  render() {
    const { history, selectObject } = this.props;
    const { isBoatloading, isHouseboatloading, isSteigerloading } = this.state;
    
    let boatButtonState = isBoatloading ? <Spinner color="text-blue" /> : "Boot";
    let houseboatButtonState = isHouseboatloading ? <Spinner color="text-blue" /> : "Woonboot";
    let steigerButtonState = isSteigerloading ? <Spinner color="text-blue" /> : "Steiger";

    return (
      <>
        <PageHeader title="Object" />
        <PageContent 
          title="Welke soort vergunning heeft u nodig?"
          goBack={() => this.props.history.goBack()}
          moveNext={() => this.props.history.push('/extend/LeafletMap')}
          cardClass="card-container"
          showFooter={true}
          hasBackBtn={true}
          hasSubmitBtn={false}>
          <form className="form-object-card">
          <Row>
            <Col md={4}>
              <a 
                className="object_types"
                onClick={() => {
                  this.setState(prevState => ({ isBoatloading: true }), () => {
                    timer = setTimeout(() => {
                      selectObject(getObjectType().boat, 'Boat')
                      history.push('/extend/LeafletMap')
                    }, 1000);
                  })
                }}>
                {!isBoatloading && <img src={require('../../../../assets/Boot@ax.jpg')} className="image-cover" />}
                {isBoatloading && <Spinner color="text-blue" />}
              </a>
              <p className="boat-object-name">Boot</p>
            </Col>
            <Col md={4}>
              <a 
                className="object_types"
                onClick={() => {
                  this.setState(prevState => ({ isHouseboatloading: true }), () => {
                    timer = setTimeout(() => {
                      selectObject(getObjectType().woonboot, 'Woonboot')
                      history.push('/extend/LeafletMap')
                    }, 1000);
                  })
                }}
                >
                {!isHouseboatloading && <img src={require('../../../../assets/Woonboot@ax.jpg')} className="image-cover" />}
                {isHouseboatloading && <Spinner color="text-blue" />}
              </a>
              <p className="boat-object-name">Woonboot</p>
            </Col>
            <Col md={4}>
              <a 
                className="object_types" 
                onClick={() => {
                  this.setState(prevState => ({ isSteigerloading: true }), () => {
                    timer = setTimeout(() => {
                      selectObject(getObjectType().steiger, 'Steiger')
                      history.push('/extend/LeafletMap')
                    }, 1000);
                  })
                }}>
                {!isSteigerloading && <img src={require('../../../../assets/Steiger@ax.jpg')} className="image-cover" />}
                {isSteigerloading && <Spinner color="text-blue" />}
              </a>
              <p className="boat-object-name">Steiger</p>
            </Col>
          </Row>
          </form>
        </PageContent>
      </>
    );
  }
}

ChooseObject.propTypes = {
  isloading: PropTypes.bool,
  error_message: PropTypes.string,
  formErrors: PropTypes.object,
  initialValues: PropTypes.object,
}

